/* global Autodesk, THREE */ // eslint-disable-line
import React from "react";
import Markups from "./Markups";
import { HOST_URL } from "../../helpers/constants/Constants";
import makeAnimated from "react-select/animated";
import { useDispatch, useSelector } from "react-redux";
import { getMarkups } from "../../helpers/actions/Action";
import axios from "axios";
import { useEffect, useState } from "react";
import Select from "react-select";
import $ from "jquery";

const MarkupPanel = () => {
  const animatedComponents = makeAnimated();
  const markupState = useSelector(
    (state) => state.markupStateReducer.markupState
  );
  const selectedProject = useSelector(
    (state) => state.getSelectedProjectReducer.data
  );
  const selectedItem = useSelector(
    (state) => state.getSelectedModelReducer.data
  );
  const viewerAppState = useSelector(
    (state) => state.markupStateReducer.viewerState
  );
  const markupExtension = useSelector(
    (state) => state.markupStateReducer.markupExtension
  );

  const markupTitle = useSelector((state) => state.markupStateReducer.title);
  const markupReviewerId = useSelector(
    (state) => state.markupStateReducer.reviewerId
  );
  const userData = useSelector((state) => state.requestUserDataReducer.data);

  const [dbMarkups, setDbMarkups] = useState();
  const [filteredMarkups, setFilteredMarkups] = useState();
  const [saving, setSaving] = useState(false);
  const [markupFilterCat, setMarkupFilterCat] = useState();
  const [searchCriteria, setSearchCriteria] = useState("");
  const [title, setTitle] = useState();
  const [userDropDownData, setUserDropDownData] = useState();
  const [selectedUser, setSelectedUser] = useState();

  const dispatch = useDispatch();

  const actionOptions = [
    { value: "", label: "" },
    { value: "true", label: "Yes" },
    { value: "false", label: "No" },
  ];

  useEffect(() => {
    console.log("UserData = ", userData);
    switch (markupState) {
      case "save":
        // $('#createModal').modal('show')
        takescreenshot();
        break;
      case "open":
        fetchMarkups();
        break;
      default:
    }
  }, [markupState]);
  const projectId = selectedProject.projectid;

  useEffect(() => {
    if (!selectedProject.projectid) {
      return;
    }
    console.log("selectedProject", selectedProject);
    axios({
      method: "Get",
      url:
        HOST_URL +
        "/api/forge/bim360/Users?projectid=" +
        selectedProject.projectid,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        var tempData = [];
        response.data.results.forEach((user) => {
          var user = {
            value: `${user.autodeskId}-${user.email}-${user.firstName} ${user.lastName}`,
            label: `${user.firstName} ${user.lastName} - ${user.email}`,
          };
          tempData.push(user);
        });
        console.log("Users -", tempData);
        setUserDropDownData(tempData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedProject]);

  const fetchMarkups = () => {
    let formData = new URLSearchParams();
    formData.append(
      "formData",
      JSON.stringify({
        projectId: String(projectId),
        documentId: String(selectedItem.id),
      })
    );

    for (const value of formData.values()) {
      console.log("formDatafetch", value);
    }

    axios({
      method: "post",
      url: HOST_URL + "/api/markups/getMarkups",
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        dispatch(getMarkups(response));
        setDbMarkups(response);
        setFilteredMarkups(response);
        // console.log("response =", response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const saveMarkup = (
    markupData,
    markupState,
    screenshot,
    callback,
    markupTitle,
    markupReviewerId
  ) => {
    console.log("ProjectID", selectedProject);
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = dd + "/" + mm + "/" + yyyy;

    const projectId = selectedProject.projectid;
    debugger;
    const markup = {
      projectId: String(projectId),
      projectName: String(selectedProject.text),
      documentId: String(selectedItem.id),
      createdDate: formattedToday,
      createdByUserId: userData.id,
      createdByName: userData.name,
      createdFor: markupReviewerId,
      actioned: false,
      title: markupTitle,
      itemId: selectedItem.id,
      documentName: selectedItem.fileName,
      markupData: [
        {
          markupId: Math.random(),
          markupTitle: markupTitle,
          markupData: markupData,
          markupstate: markupState,
          imagePreview: screenshot,
          documentName: selectedItem.fileName,
          documentVersion: `V${selectedItem.version}`,
          // pwVersion: pwDocVersion,
          userName: `${userData.name}`,
          created: formattedToday,
          createdFor: markupReviewerId,
          actioned: false,
        },
      ],
    };
    debugger;
    let formData = new FormData();
    formData.append("formData", JSON.stringify(markup));
    for (const value of formData.values()) {
      console.log("formData", value);
    }

    axios({
      method: "post",
      url: HOST_URL + "/api/markups/saveMarkup",
      data: formData,

      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    })
      .then((response) => {
        console.log("response =", response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        callback();
      });
    setSaving(false);
  };

  const takescreenshot = async () => {
    // const promptInput = await prompt("Please enter a title for markup");
    // const promptInput2 = await prompt(
    //   "Please enter who the markup is intended for"
    // ); -----------Removed to use state instead

    //Added to be sure any pending text is not lost
    let rectangle =
      new Autodesk.Viewing.Extensions.Markups.Core.EditModeRectangle(
        markupExtension
      );
    markupExtension.changeEditMode(rectangle);
    setSaving(true);
    debugger;
    const screenshot = await getViewerScreenshot(viewerAppState);
    const canvas = await addMarkupsToScreenshot(viewerAppState, screenshot);
    const link = canvas.toDataURL();
    var markupsStringData = markupExtension.generateData();
    var markupState = markupExtension.viewer.getState();
    saveMarkup(
      markupsStringData,
      markupState,
      link,
      fetchMarkups,
      markupTitle,
      markupReviewerId
    );
    markupExtension.leaveEditMode();
    markupExtension.hide();
  };

  const getViewerScreenshot = (viewer) => {
    return new Promise((resolve, reject) => {
      const screenshot = new Image();
      screenshot.onload = () => resolve(screenshot);
      screenshot.onerror = (err) => reject(err);
      viewer.getScreenShot(
        viewer.container.clientWidth,
        viewer.container.clientHeight,
        (blobURL) => {
          screenshot.src = blobURL;
        }
      );
    });
  };

  const addMarkupsToScreenshot = (viewer, screenshot) => {
    return new Promise((resolve, reject) => {
      const markupCoreExt = viewer.getExtension("Autodesk.Viewing.MarkupsCore");
      const canvas = document.createElement("canvas");
      canvas.width = viewer.container.clientWidth;
      canvas.height = viewer.container.clientHeight;
      const context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(screenshot, 0, 0, canvas.width, canvas.height);
      markupCoreExt.renderToCanvas(context, () => resolve(canvas));
    });
  };

  const markupFilterHandler = (e) => {
    setMarkupFilterCat(e.value);
    setSearchCriteria("");
    setFilteredMarkups(dbMarkups);
  };
  const selectOptions = [
    { value: "", label: "No Filter" },
    { value: "User", label: "Created by" },
    { value: "createdFor", label: "Created for" },
    { value: "actioned", label: "Completed" },
  ];

  const filterMarkups = (e) => {
    let value;
    if (e.target) {
      setSearchCriteria(e.target.value);
      value = e.target.value;
    } else {
      value = e;
    }
    console.log("value = ", value);
    if (markupFilterCat === "User") {
      const tempMarkups = dbMarkups.data.filter((name) => {
        return name.markupData[0].userName
          .toLowerCase()
          .includes(value.toLowerCase());
      });
      const tempMarkupData = {
        data: tempMarkups,
      };
      setFilteredMarkups(tempMarkupData);
    } else if (markupFilterCat === "createdFor") {
      const tempMarkups = dbMarkups.data.filter((ver) => {
        return ver.markupData[0].createdFor
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      });
      const tempMarkupData = {
        data: tempMarkups,
      };
      setFilteredMarkups(tempMarkupData);
    } else if (markupFilterCat === "version") {
      const tempMarkups = dbMarkups.data.filter((ver) => {
        return ver.markupData[0].pwVersion
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      });
      const tempMarkupData = {
        data: tempMarkups,
      };
      setFilteredMarkups(tempMarkupData);
    } else if (markupFilterCat === "actioned") {
      const tempMarkups = dbMarkups.data.filter((ver) => {
        return ver.markupData[0].actioned
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      });
      const tempMarkupData = {
        data: tempMarkups,
      };
      setFilteredMarkups(tempMarkupData);
    }
  };

  const updateMarkup = (markup) => {
    let formData = new FormData();
    formData.append("formData", JSON.stringify(markup));
    // // for (const value of formData.values()) {
    // //   console.log("formData", value);
    // // }

    axios({
      method: "post",
      url: HOST_URL + "/api/markups/updateMarkup",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    })
      .then((response) => {
        console.log("response =", response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const checkboxChangeHandler = (e) => {
    console.log(e.target.checked);
    console.log("id =", e.target.id);
    console.log("DBMARKUPS = ", dbMarkups);
    let tempMarkups2 = {
      data: filteredMarkups.data.filter(
        (markup) => markup.id.toString() === e.target.id
      ),
    };
    tempMarkups2.data[0].markupData[0].actioned = e.target.checked;

    console.log("TempMarkups2 =", tempMarkups2);
    const tempMarkups = {
      data: filteredMarkups.data.map((markup) => {
        console.log("markup = ", markup);
        if (markup.id.toString() === e.target.id) {
          console.log("Filtered");
          return {
            ...markup,
            markupData: [
              { ...markup.markupData[0], actioned: e.target.checked },
            ],
          };
        } else {
          return { ...markup };
        }
      }),
    };
    console.log("TempMarkups =", tempMarkups);

    setFilteredMarkups(tempMarkups);
    updateMarkup(tempMarkups2.data[0]);
    // filterMarkups(searchCriteria);
  };

  const exitEditMode = (screenshot) => {
    debugger;
    markupExtension.leaveEditMode();
    markupExtension.hide();
  };

  const loadMarkup = (id) => {
    // console.log("overallmarkupData", dbMarkups);
    // console.log("markupData", dbMarkups.data[id].markupData[0].markupData);
    // console.log("markupState", dbMarkups.data[id].markupData[0].markupstate);
    const filteredMarkupData = dbMarkups.data.filter(
      (markup) => markup.id === id
    );
    console.log("markupData =", filteredMarkupData);
    exitEditMode();
    markupExtension.viewer.restoreState(
      filteredMarkupData[0].markupData[0].markupstate
    );
    setTimeout(() => {
      markupExtension.show();
      markupExtension.loadMarkups(
        filteredMarkupData[0].markupData[0].markupData,
        "Layer_1"
      );
    }, 500);
  };

  return (
    <div>
      <h2>Markup Panel</h2>
      <Markups />
      <Select
        onChange={markupFilterHandler}
        options={selectOptions}
        defaultValue={selectOptions[0]}
      />
      {markupFilterCat ? (
        markupFilterCat === "actioned" ? (
          <>
            <br></br>
            <div>
              <Select
                onChange={(e) => filterMarkups(e.value)}
                options={actionOptions}
                // defaultValue={actionOptions[0]}
              />
            </div>
          </>
        ) : (
          <>
            <br></br>
            <div className="form-floating mb-3 markup-filter">
              <input
                type="input"
                className="form-control markup-filterText"
                id="floatingInput"
                placeholder="username"
                value={searchCriteria}
                onChange={(e) => filterMarkups(e)}
              />
              <label for="floatingInput" className="markup-filterText">
                Enter search criteria
              </label>
            </div>
          </>
        )
      ) : (
        <></>
      )}
      <br />
      <div className="markup-list">
        {filteredMarkups ? (
          filteredMarkups.data.map((markup, i) => {
            return (
              <div
                key={markup.id}
                className="card text-white bg-secondary mb-3"
                style={{ maxWidth: "100%" }}>
                <div className="card-header markup-header">
                  <p className="card-text markup-text">
                    Completed: {console.log(markup.markupData[0].actioned)}
                    <input
                      className="form-check-input"
                      type="checkbox"
                      // value={markup.markupData[0].actioned}
                      checked={markup.markupData[0].actioned}
                      id={markup.id}
                      onChange={(e) => checkboxChangeHandler(e)}
                      // style={{marginRight: "0.5rem"}}
                    />
                    <span style={{ marginLeft: "1rem" }}>
                      {" - "}
                      {markup.markupData[0].markupTitle}
                    </span>
                  </p>
                </div>

                <div
                  className="card-body markup-body"
                  onClick={() => loadMarkup(markup.id)}>
                  <div className="row">
                    <div className="col-5" style={{ paddingRight: "0" }}>
                      <img
                        className="markup-preview"
                        src={markup.markupData[0].imagePreview}
                        alt=""></img>
                    </div>
                    <div className="col-7" style={{ paddingLeft: "2px" }}>
                      <p className="card-text markup-text">
                        Created by: {markup.markupData[0].userName}
                      </p>
                      <p className="card-text markup-text">
                        Created on: {markup.markupData[0].created}
                      </p>
                      <p className="card-text markup-text">
                        Created for: {markup.markupData[0].createdFor}
                      </p>
                      {/* <p className="card-text markup-text">
                            Actioned:{" "}
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={markup.markupData[0].actioned}
                              id="flexCheckDefault"
                              onChange={(e) => checkboxChangeHandler(e)}
                            />
                          </p> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <></>
        )}
      </div>
      {/* <div
        className="modal fade"
        id="createModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="createModalLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="creatModalLabel">
                Create Markup
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-2">
                  <label>Title</label>
                </div>
                <div className="col">
                  <textarea
                    className="form-control"
                    type="text"
                    id="workflowInput"
                    placeholder="Comment"
                    rows="10"
                    onChange={(e) => {setTitle(e.target.value)}}
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-2">
                  <label>Reviewer</label>
                </div>
                <div className="col">
                  <Select
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    defaultValue={[]}
                    // isMulti
                    options={userDropDownData}
                    onChange={(e) => {setSelectedUser(e.target.value)}}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-success p-2"
                onClick={(e) => takescreenshot()}
                data-dismiss="modal">
                Create
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default MarkupPanel;
